import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { Constantes } from '@services/util/constantes';
import { AccessGuard } from './access-guard.component';
import { AccueilComponent } from './accueil/accueil.component';
import { AuthComponent } from './auth/auth.component';
import { PageInaccessibleComponent } from './divers/pageinaccessible/pageinaccessible.component';
import { PageNotFoundComponent } from './divers/pagenotfound/pagenotfound.component';
import { ListeSyncListeComponent } from './listessynchro/listesync.component';
import { ProfilListeComponent } from './profil/profil.component';
import { SuiviImportListeComponent } from './suivi/import/pages/suivi-import-liste.component';
import { PlansTourneeComponent } from './suivi/plans-tournee/pages/plans-tournee.component';
import { PFClientListeComponent } from './suiviagents/pfClient.component';
import { ClientsComponent } from './suiviclients/clients.component';
import { SortiesULListeComponent } from './tablesreference/sorties-UL/sorties-ul-liste/sorties-ul-liste.component';

const routes: Routes = [
    { path: '', component: AccueilComponent },
    { path: 'auth', component: AuthComponent },
    {
        path: 'analysessup',
        loadChildren: () => import('./services/analysessup/anasup.module').then(m => m.AnasupModule),
        canActivate: [AccessGuard],
        data: { codeModuleList: [Constantes.CodeOption.MANASUP] }
    },
    {
        path: 'controleperfs',
        loadChildren: () => import('./services/controle-perf/controle-perf.module').then(m => m.ControlePerfModule),
        canActivate: [AccessGuard],
        data: { codeModuleList: [Constantes.CodeOption.MCONTROLEPERF] }
    },
    {
        path: 'mir',
        loadChildren: () => import('./services/mir/mir.module').then(m => m.MirModule),
        canActivate: [AccessGuard],
        data: { codeModuleList: [Constantes.CodeOption.MMIR] }
    },
    {
        path: 'suivi/pointage',
        loadChildren: () => import('./pointage/pointage.module').then(m => m.PointageModule),
        canActivate: [AccessGuard],
        data: { codeModuleList: [Constantes.CodeOption.MPOINTAGE, Constantes.CodeOption.MPOINTAGEAGENT] }
    },
    {
        path: 'utilisateurs',
        loadChildren: () => import('./utilisateur/utilisateur.module').then(m => m.UtilisateurModule),
        canActivate: [AccessGuard],
        data: { codeModuleList: [Constantes.CodeOption.OFICHIERUSER] }
    },
    {
        path: 'suiviactivite',
        loadChildren: () => import('./suiviactivite/suivi-activite.module').then(m => m.SuiviActiviteModule)
    },
    {
        path: 'organismes',
        loadChildren: () => import('./organismes/organismes.module').then(m => m.OrganismesModule),
        canActivate: [AccessGuard],
        data: { codeModuleList: [Constantes.CodeOption.OFICHIERORGA] }
    },
    {
        path: 'documents',
        loadChildren: () => import('./document/document.module').then(m => m.DocumentModule),
        // pas de code module car celui-ci n'est plus accessible
    },
    {
        path: 'abonnements',
        loadChildren: () => import('./abonnement/abonnement.module').then(m => m.AbonnementModule),
        canActivate: [AccessGuard],
        data: { codeModuleList: [Constantes.CodeOption.MABONNEMENT] }
    },
    {
        path: 'listesync',
        component: ListeSyncListeComponent,
        canActivate: [AccessGuard],
        data: { codeModuleList: [Constantes.CodeOption.MSYNCHRO] }
    },
    {
        path: 'profil',
        component: ProfilListeComponent,
        canActivate: [AccessGuard],
        data: { codeModuleList: [Constantes.CodeOption.OFICHIERDROIT] }
    },
    {
        path: 'clients',
        component: ClientsComponent,
        canActivate: [AccessGuard],
        data: { codeModuleList: [Constantes.CodeOption.MCLIENT] }
    },
    {
        path: 'pfclient/:usrid',
        component: PFClientListeComponent,
        canActivate: [AccessGuard],
        data: { codeModuleList: [Constantes.CodeOption.MPORTEFEUILLE] }
    },
    {
        path: 'suivi/planstournee',
        component: PlansTourneeComponent,
        canActivate: [AccessGuard],
        data: { codeModuleList: [Constantes.CodeOption.MSUIVIPLANSTOURNEE] }
    },
    {
        path: 'sortiesUL',
        component: SortiesULListeComponent,
        canActivate: [AccessGuard],
        data: { codeModuleList: [Constantes.CodeOption.MSORTIESUL] }
    },
    {
        path: 'suivi/imports',
        component: SuiviImportListeComponent,
        canActivate: [AccessGuard],
        data: { codeModuleList: [Constantes.CodeOption.MSUIVIIMPORTS] }
    },
    { path: 'pageinaccessible', component: PageInaccessibleComponent },
    { path: '**', component: PageNotFoundComponent }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true, preloadingStrategy: PreloadAllModules })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
